import {updateTemplateNameRequest} from '../../actions/docTemplates'
import store from '../../store'

export function updateTemplateName(templateId,name){
	return store.dispatch(updateTemplateNameRequest(templateId,name))
}
